import { SUPPORTED_LANGUAGE_CODES, LANGUAGE_CODE_DEFAULT, LANGUAGE_CODE_DEV } from '@procureai/schemas';

export const languages = SUPPORTED_LANGUAGE_CODES;
export const defaultLanguage = LANGUAGE_CODE_DEFAULT;
export const devLanguage = LANGUAGE_CODE_DEV;
